import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { UIAccordion } from "../../../../ui";
import WorkingShifts from "../WorkingShifts";
import GenderCountsGroup from "../../GenderCount/GenderCountsGroup";
import messages from "../../../../../assets/locale/messages";

import "./RoleItem.scss";
import "../../_EventDetailFields.scss";

const RoleHeader = ({ role }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { events } = messages[lang];
  const t = events.viewEvents;

  return (
    <Box
      className="event-role-item__header"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        minWidth: 0,
        flex: 1,
        justifyContent: "space-between",
      }}
    >
      <Box className="event-role-item__title" sx={{ minWidth: 0 }}>
        <span className="event-detail-accordion-title">
          {lang === "en" ? role?.role?.name_en : role?.role?.name_ar || role?.role?.name}
        </span>
        {role?.tier_name && (
          <Typography
            sx={{
              fontSize: 10,
              fontWeight: 700,
              lineHeight: "15px",
              letterSpacing: "1px",
              color: "var(--color-foreground-muted)",
              display: "block",
            }}
          >
            {role.tier_name}
          </Typography>
        )}
      </Box>

      <GenderCountsGroup
        className="event-role-item__gender-counts"
        maleLabel={t.male}
        femaleLabel={t.female}
        maleCount={role?.maximum_number_of_males}
        femaleCount={role?.maximum_number_of_females}
      />
    </Box>
  );
};

RoleHeader.propTypes = {
  role: PropTypes.object.isRequired,
};

const RoleItem = ({ role, defaultExpanded, portalVariant }) => {
  const shifts =
    role?.event_role_shifts_attributes ?? role?.event_role_shifts ?? [];

  return (
    <UIAccordion
      hasCustomizeTitle
      defaultExpanded={defaultExpanded}
      id={`role-${role?.id ?? role?.role_id}`}
      title={<RoleHeader role={role} />}
      classNames={{
        root: "event-role-item",
        body: "p-32",
      }}
    >
      <WorkingShifts
        shifts={shifts}
        uniformCode={role?.uniform_code}
        portalVariant={portalVariant}
      />
    </UIAccordion>
  );
};

RoleItem.propTypes = {
  role: PropTypes.object.isRequired,
  defaultExpanded: PropTypes.bool,
  portalVariant: PropTypes.oneOf(["company-portal", "client-portal"]),
};

RoleItem.defaultProps = {
  defaultExpanded: false,
  portalVariant: "company-portal",
};

export default RoleItem;
